import { autoinject } from "aurelia-framework";

import { default as dispatchService } from "services/dispatchService";

import { EmployeeModelBase } from "api/models/company/employee/employee-model-base";

@autoinject()
export class OtherDispatchedEmployees {
    public dispatchId: number = 0;
    public serviceType: string = "W";
    public employees: EmployeeModelBase[] = [];

    public bindViewModel(serviceType: string, dispatchId: number): void {
        this.serviceType = serviceType;
        this.dispatchId = dispatchId;
    }

    public async loadData(): Promise<void> {
        this.employees = await dispatchService.getOtherDispatchedEmployees(this.dispatchId);
    }

    public async activate(params: any): Promise<void> {
        this.bindViewModel(params.serviceType, params.dispatchId);
        return await this.loadData();
    }
}
